import React from 'react'
import * as UI from 'ui'
import { Card } from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import { Link } from '@morningtrain/react-navigation'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import StartCheckupButton from 'pages/app/cleaning/partials/StartCheckupButton'
import CleaningDepartment from 'support/displays/CleaningDepartment'
import LatestCheckups from './partials/LatestCheckups'
import AdminPageWithSmartview from '../AdminPageWithSmartview'

export default function Summary () {
  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false}>
      <Translator namespace='cleaning'>
        <UI.PageHeader title={<TranslatedTitle name='titles.summary' />}>
          <UI.ButtonWrap>
            <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
              <Link route='app.cleaning.templates'>
                <UI.Button>
                  <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Settings />}>
                    <Translation name='actions.manage_templates' />
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </Can>
            <Can permission={Permissions.CLEANING_CHECKUPS_MANAGE}>
              <Link route='app.cleaning.checkups'>
                <UI.Button>
                  <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Eye />}>
                    <Translation name='actions.view_checkups' />
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </Can>
            <StartCheckupButton />
          </UI.ButtonWrap>
        </UI.PageHeader>

        <Collection resourceName='cleaning.checkup_department'>
          <WhenCollectionIsNotEmpty>
            <Card>
              <Translator namespace='cleaning.summary'>
                <Table>
                  <Columns.Column display={<CleaningDepartment />} />
                  <Columns.Text
                    name='latest_checkups'
                    display={<LatestCheckups />}
                    label={<Translation name='cleaning.checkups.latest_checkups' />}
                  />
                  <Columns.DateTime
                    name='latest_checkup_at'
                    sortable
                    sortSlug='orderByLatestCheckup'
                    label={<Translation name='cleaning.checkups.latest_checkup_at' />}
                  />
                  <Columns.Text name='excellent' />
                  <Columns.Text name='ok' />
                  <Columns.Text name='fix_now' />
                  <Columns.Text name='warning' />
                </Table>
              </Translator>
            </Card>
          </WhenCollectionIsNotEmpty>
        </Collection>
      </Translator>
    </AdminPageWithSmartview>
  )
}
